import React from "react"
import _ from "lodash"
import Color from "color"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars } from '@fortawesome/free-solid-svg-icons'

import $ from "jquery"
import styled from "styled-components"

import MenuLayer from "./MenuLayer"

import "./PersistentMenu.scss"

const LUM_THRESHOLD = 0.6

const MenuButton = styled.button`
  cursor: pointer;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -webkit-tap-highlight-color: transparent;
  color: ${(props) => {
    if (props.disabled) {
      return "#ccc"
    }
    if (props.color) {
      const bg = Color(props.color)
      if (bg.luminosity() > LUM_THRESHOLD) {
        return "#0084FF"
      }
      return props.color
    }
    return "#0084FF"
  }};
  font-size: 20px !important;

  >label {
    cursor: pointer;
  }
`
class PersistentMenu extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      openMenu: false,
      path: null,
    }

    this.onGlobalClick = this.onGlobalClick.bind(this)
  }

  componentDidMount() {
    document.addEventListener("click", this.onGlobalClick)
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.onGlobalClick)
  }

  onGlobalClick(e) {
    if ($(e.target).closest(".radiate-webchat-element.persistent-menu").length <= 0) {
      this.setState({
        openMenu: false
      })
    }
  }

  render() {
    const { persistentMenu, color, memberId, fontSize, disabled } = this.props
    const buttons = _.get(persistentMenu, "buttons")
    let buttonColor = "#0084FF"
    if (color) {
      const bg = Color(color)
      if (bg.luminosity() > LUM_THRESHOLD) {
        buttonColor = "#0084FF"
      } else {
        buttonColor = color
      }
    }
    return (
      <div className="radiate-webchat-element persistent-menu popper-container">
        <MenuButton
          diasbled={disabled}
          color={color}
          onClick={() => {
            if (disabled) {
              return
            }
            this.setState({
              openMenu: !this.state.openMenu,
              // path: null,
            })
          }}
          className="menu-hamburger-button"
        >
          <FontAwesomeIcon
            className="icon"
            icon={faBars}
            style={{ color: buttonColor }}
            fixedWidth
          />
        </MenuButton>
        {this.state.openMenu ?
          <div className="popper-element">
            <MenuLayer
              memberId={memberId}
              persistentMenu={persistentMenu}
              // path={this.state.path}
              color={color}
              items={buttons}
              fontSize={fontSize}
              onSelectButton={(button) => {
                if (button.type === "postback") {
                  this.props.onAction({
                    type: "postback",
                    title: button.title,
                    payload: button.payload
                  })
                  this.setState({
                    openMenu: false,
                    path: null,
                  })
                }
              }}
              onNavBack={(e) => {
                e.stopPropagation()
                e.nativeEvent.stopImmediatePropagation()
                const pathSplit = this.state.path.split(".")
                if (pathSplit.length > 2) {
                  const newPathSplit = pathSplit.slice(0, pathSplit.length - 2)
                  this.setState({
                    path: newPathSplit.join(".")
                  })
                } else {
                  this.setState({
                    path: null
                  })
                }
              }}
            />
          </div>                
          :
          null
        }
      </div>
    )
  }
}

export default PersistentMenu
